﻿import { ValgStateActionTypes, ValgState, TOGGLE_VILKAR, UPDATE_VALG } from './Types';

export const initialState: ValgState = {
    aInfo: undefined,
    bInntektOgBarn: false,
    cInntekt: undefined,
    cAntallBarn: undefined,
    visVilkar: false,
};

export function valgReducer(state: ValgState = initialState, action: ValgStateActionTypes): ValgState {
    const newState = getNewState();
    return newState;

    function getNewState(): ValgState {
        switch (action.type) {
            case UPDATE_VALG: {
                if (action.payload.aInfo) {
                    return {
                        ...initialState,
                        ...action.payload,
                    };
                } else {
                    return {
                        ...state,
                        ...action.payload,
                    };
                }
            }
            case TOGGLE_VILKAR: {
                return {
                    ...state,
                    visVilkar: !state.visVilkar,
                };
            }
            default:
                return state;
        }
    }
}
